// AUTO-GENERATED by scripts/build-content.ts from content/portfolio.yaml + content/prose/*.md.
// Do not edit by hand. Run `bun run content:build` to regenerate.
export const generatedContent = {
  "name": "Muhammad Yousaf Rana",
  "title": "AI Engineer",
  "assistantName": "Robo-Yousaf",
  "shortName": "Yousaf",
  "headerLabel": "AI Engineer Portfolio",
  "contact": {
    "email": "yousaf.mlengineer@gmail.com",
    "location": "Islamabad, Pakistan",
    "linkedinPath": "linkedin.com/in/muhammad-yousaf-rana-a96637234/",
    "profiles": [
      {
        "label": "GitHub",
        "url": "https://github.com/Muhammadyousafrana"
      },
      {
        "label": "Kaggle",
        "url": "https://www.kaggle.com/josephengineer112"
      },
      {
        "label": "Hugging Face",
        "url": "https://huggingface.co/MYousafRana"
      },
      {
        "label": "Credly",
        "url": "https://www.credly.com/users/mohammad-yousaf-rana"
      },
      {
        "label": "Google Developer",
        "url": "https://me.developers.google.com/u/yousafrana"
      }
    ]
  },
  "seo": {
    "title": "Muhammad Yousaf Rana | AI Engineer",
    "description": "AI Engineer building multimodal machine-learning systems across computer vision, audio, generative modeling, MLOps, and edge inference.",
    "ogTitle": "Muhammad Yousaf Rana | AI Engineer",
    "ogDescription": "Explore Yousaf's work in multimodal AI, computer vision, audio ML, MLOps, and on-device inference.",
    "themeColor": "#0f172a"
  },
  "resumePdfPath": null,
  "summary": "AI Engineer with hands-on experience across computer vision, audio, generative modeling, and NLP, developing machine-learning systems from training through deployment. Work includes multimodal drone detection, parameter-efficient language-model fine-tuning, containerized simulation pipelines, and quantized on-device inference across Android, browser, and embedded platforms.",
  "targetRoles": [
    "Machine Learning Engineer",
    "MLOps Engineer",
    "Edge AI Engineer"
  ],
  "starterPrompts": [
    "How does the multimodal drone detection work combine acoustic, vision, and RF signals?",
    "What changed when the computer vision models were quantized for edge inference?",
    "How does DroneWatch detect drone signatures fully on-device?"
  ],
  "homepage": {
    "openToLabel": "Open to AI, MLOps, and Edge AI Roles",
    "roleFocus": "Production AI · MLOps · Edge Inference",
    "heroHeadline": "Engineering practical AI systems from model research to reliable edge deployment.",
    "ctaHeadline": "Building AI systems that move from experiments into real use.",
    "ctaSubtext": "Explore work across multimodal detection, computer vision, audio ML, generative AI, and on-device inference.",
    "proofPoints": [
      {
        "sourceId": "pof-multimodal-drone-detection",
        "title": "Multimodal Drone Detection",
        "detail": "Combined acoustic, computer-vision, and RF signals with sensor fusion for airspace surveillance."
      },
      {
        "sourceId": "den-edge-models",
        "title": "Efficient Edge Inference",
        "detail": "INT8 quantization reduced model footprint by 70% while maintaining sub-30 ms on-device inference."
      },
      {
        "sourceId": "dronewatch",
        "title": "On-Device AI",
        "detail": "Built an Android app for real-time acoustic drone detection using LiteRT without cloud dependency."
      }
    ]
  },
  "education": [
    {
      "school": "University of Engineering and Technology Taxila (UET Taxila)",
      "degree": "B.S. Software Engineering · GPA 3.42/4.0",
      "coursework": []
    }
  ],
  "experience": [
    {
      "id": "pof-multimodal-drone-detection",
      "company": "Pakistan Ordnance Factories (POF), R&D Department",
      "role": "AI/ML Engineer",
      "description": "Developed multimodal drone detection and autonomy simulation systems for airspace surveillance.",
      "bullets": [
        "Integrated acoustic, computer-vision, and RF signal sources through sensor fusion.",
        "Built an acoustic detection model using an 8-channel microphone array, log-mel spectrograms, GCC-PHAT features, and an EfficientNetV2 backbone.",
        "Trained multi-task outputs for drone presence, distance, altitude, and rotation.",
        "Built drone autonomy simulations and reinforcement-learning pipelines in NVIDIA Isaac Sim and Isaac Lab, and packaged the environment as a public Docker image."
      ],
      "links": [
        {
          "label": "Docker Hub",
          "url": "https://hub.docker.com/r/oseph13243/isaac-lab-drone"
        },
        {
          "label": "Acoustic Detection Notebook",
          "url": "https://colab.research.google.com/drive/1Zzhmfs9KEtjJTdB1U7OPyOTUjX5h37li?usp=sharing"
        }
      ]
    },
    {
      "id": "den-edge-models",
      "company": "Digital Empowerment Network",
      "role": "AI/ML Engineer Intern",
      "description": "Deployed lightweight computer-vision models to mobile, browser, and embedded edge platforms.",
      "bullets": [
        "Delivered inference in Android applications, in-browser with TensorFlow.js and WebGL, and on embedded IoT devices.",
        "Applied post-training INT8 quantization, reducing model footprint by 70% while maintaining sub-30 ms on-device inference latency."
      ],
      "links": [
        {
          "label": "Android On-Device Detection",
          "url": "https://github.com/Muhammadyousafrana/Android-OnDevice-Object-Detection"
        },
        {
          "label": "Quantization Notebook",
          "url": "https://colab.research.google.com/drive/1By39RlJh_AOZQ3_fLZVzDcryP6XLRTRv?usp=sharing"
        }
      ]
    },
    {
      "id": "ezitech-generative-models",
      "company": "EZITECH",
      "role": "AI/ML Engineer Intern",
      "description": "Trained deep generative architectures and evaluated image generation fidelity.",
      "bullets": [
        "Implemented Neural Style Transfer, variational autoencoders, DCGAN, and conditional Spectral-Normalized WGAN from scratch.",
        "Used latent-space disentanglement and WGAN-GP loss to address mode collapse and assess generation quality."
      ],
      "links": [
        {
          "label": "Neural Style Transfer",
          "url": "https://colab.research.google.com/drive/12eU0S219Tmk5Ix7ayil-b_OxrZiXXjOe?usp=sharing"
        },
        {
          "label": "Variational Autoencoder",
          "url": "https://colab.research.google.com/drive/1fJNHs3_59L8jwIQ-xoPLJ4HOlErOMbIq?usp=sharing"
        },
        {
          "label": "DCGAN",
          "url": "https://colab.research.google.com/drive/12Qr3Y5FCZqOvlUjeK2C3QJf-47FXlOOg?usp=sharing"
        },
        {
          "label": "Conditional SN-WGAN",
          "url": "https://colab.research.google.com/drive/17I8b5QFKJ9nJssUqt5MC4cmlC_-fSap2?usp=sharing"
        }
      ]
    },
    {
      "id": "internncraft-llm-finetuning",
      "company": "InternnCraft",
      "role": "AI/ML Engineer Intern",
      "description": "Applied parameter-efficient fine-tuning and reinforcement learning to language-model reasoning tasks.",
      "bullets": [
        "Fine-tuned DeepSeek-Math-7B-Instruct with PEFT and LoRA for task-specific mathematical and algorithmic reasoning.",
        "Implemented a Group Relative Policy Optimization loop to align generations with multi-step reasoning constraints."
      ],
      "links": [
        {
          "label": "DeepSeek Math LoRA Notebook",
          "url": "https://colab.research.google.com/drive/1nMlLPg091nv_yIK69ijUdTkODLmSSony?usp=sharing"
        },
        {
          "label": "GRPO Notebook",
          "url": "https://colab.research.google.com/drive/1LTnRuKTixYKe0jqXpa19Tj8ORtVMmEUk?usp=sharing"
        }
      ]
    }
  ],
  "projects": [
    {
      "id": "dronewatch",
      "name": "DroneWatch — On-Device Acoustic Drone Detection",
      "description": "Kotlin and Jetpack Compose Android app for real-time acoustic drone detection.",
      "bullets": [
        "Processes live microphone streams and audio files with LiteRT entirely on-device, without cloud dependency."
      ],
      "links": [
        {
          "label": "GitHub",
          "url": "https://github.com/Muhammadyousafrana/dronewatch"
        }
      ]
    },
    {
      "id": "motiondit",
      "name": "MotionDiT — Text-to-Motion Diffusion Transformer",
      "description": "PyTorch text-conditioned diffusion transformer for generating 3D human motion from natural-language prompts.",
      "bullets": [
        "Uses CLIP text conditioning, timestep embeddings, and masked temporal self-attention with the HumanML3D dataset.",
        "Includes dataset preparation, training, and motion-visualization tools for a 272-dimensional motion representation."
      ],
      "links": [
        {
          "label": "GitHub",
          "url": "https://github.com/Muhammadyousafrana/motiondit"
        }
      ]
    },
    {
      "id": "summedify",
      "name": "Summedify — Enterprise Multimedia Summarization",
      "description": "Full-stack multimodal AI platform for text, documents, audio, and video summarization.",
      "bullets": [
        "Integrates LLaVA-NeXT-Video-7B, OpenAI Whisper, and Meta NLLB-200 behind multilingual FastAPI endpoints."
      ],
      "links": [
        {
          "label": "Main Repository",
          "url": "https://github.com/Muhammadyousafrana/media-summarizer-api"
        },
        {
          "label": "Document Summarizer",
          "url": "https://github.com/Muhammadyousafrana/doc-summarizer-api"
        },
        {
          "label": "Audio Transcription",
          "url": "https://github.com/Muhammadyousafrana/native-language-audio-transcription"
        }
      ]
    },
    {
      "id": "drone-audio-detection",
      "name": "Drone Audio Detection Pipeline",
      "description": "Source-aware audio preprocessing and classification pipeline built with TensorFlow/Keras and Google's YAMNet architecture.",
      "bullets": [
        "Includes automated data cleaning, spectral augmentations, and exported TensorFlow Lite models."
      ],
      "links": [
        {
          "label": "GitHub",
          "url": "https://github.com/Muhammadyousafrana/drone-audio-detection"
        }
      ]
    },
    {
      "id": "arxiv-rag-mcp",
      "name": "arXiv Paper RAG & Research MCP Servers",
      "description": "Model Context Protocol servers for literature search, paper indexing, and research workflows.",
      "bullets": [
        "Enable agents to query arXiv, index papers into semantic vector stores, extract PDF content, and orchestrate literature reviews."
      ],
      "links": [
        {
          "label": "Paper RAG MCP",
          "url": "https://github.com/Muhammadyousafrana/arxiv-paper-rag-mcp"
        },
        {
          "label": "Research MCP",
          "url": "https://github.com/Muhammadyousafrana/arxiv-research-mcp"
        }
      ]
    },
    {
      "id": "mlops-multiregistry",
      "name": "CI/CD MLOps & Multi-Registry Deployment",
      "description": "Automated deployment pipelines for a containerized FastAPI GPT-2 inference service.",
      "bullets": [
        "Publishes images to GitHub Container Registry, Docker Hub, and Azure Container Registry, with models hosted on Hugging Face."
      ],
      "links": [
        {
          "label": "GHCR Pipeline",
          "url": "https://github.com/Muhammadyousafrana/gpt2-fastapi-ghcr"
        },
        {
          "label": "Docker Hub Pipeline",
          "url": "https://github.com/Muhammadyousafrana/gpt2-fastapi-dockerhub"
        },
        {
          "label": "Azure Registry Pipeline",
          "url": "https://github.com/Muhammadyousafrana/huggingface-azure-container-registry"
        }
      ]
    },
    {
      "id": "inception-resnet-v2",
      "name": "Inception-ResNet-v2 from Scratch in PyTorch",
      "description": "Ground-up PyTorch implementation with a Caltech-256 training pipeline.",
      "bullets": [
        "Includes TensorBoard monitoring, custom learning-rate schedulers, checkpointing, and torch.export deployment support."
      ],
      "links": [
        {
          "label": "GitHub",
          "url": "https://github.com/Muhammadyousafrana/inception-resnet-v2-pytorch"
        }
      ]
    },
    {
      "id": "dwellwatch",
      "name": "DwellWatch — AI Vehicle Dwell-Time Analytics",
      "description": "Flask application that measures vehicle dwell time from live RTSP and webcam feeds.",
      "bullets": [
        "Uses YOLO detection and ByteTrack object tracking through an integrated Roboflow workflow."
      ],
      "links": [
        {
          "label": "GitHub",
          "url": "https://github.com/Muhammadyousafrana/dwellwatch"
        }
      ]
    },
    {
      "id": "medical-paper-classifier",
      "name": "Medical Paper Classifier",
      "description": "Contextual sentence classification framework for medical and biomedical research abstracts.",
      "bullets": [
        "Developed a TensorFlow NLP model to classify sections (e.g., Abstract, Methods) in medical research papers."
      ],
      "links": [
        {
          "label": "Article",
          "url": "https://www.researchgate.net/profile/Muhammad-Rana-44/publication/393600460_An_Optimized_Framework_for_Contextual_Sentence_Classification_in_Biomedical_Abstracts/links/6870df4cae516743559bf291/An-Optimized-Framework-for-Contextual-Sentence-Classification-in-Biomedical-Abstracts.pdf"
        }
      ]
    },
    {
      "id": "additional-github-projects",
      "name": "Additional GitHub Projects",
      "description": "More repositories featured on my resume.",
      "bullets": [
        "Open a repository to explore its implementation and project details."
      ],
      "links": [
        {
          "label": "Agent Orchestrator",
          "url": "https://github.com/Muhammadyousafrana/agent-orchestrator"
        },
        {
          "label": "CareerPilot",
          "url": "https://github.com/Muhammadyousafrana/CareerPilot"
        },
        {
          "label": "Image Denoising Autoencoder",
          "url": "https://github.com/Muhammadyousafrana/ImageDenoise-AutoEncoder"
        },
        {
          "label": "Music Generator",
          "url": "https://github.com/Muhammadyousafrana/MusicGenerator"
        },
        {
          "label": "Movie Sentiment AI",
          "url": "https://github.com/Muhammadyousafrana/MovieSentimentAI"
        },
        {
          "label": "WikiPhrase NLP",
          "url": "https://github.com/Muhammadyousafrana/WikiPhraseNLP"
        },
        {
          "label": "SummarEase",
          "url": "https://github.com/Muhammadyousafrana/SummarEase-Hugging-Face-Text-Summarizer"
        }
      ]
    },
    {
      "id": "research-notebooks",
      "name": "Research Notebooks",
      "description": "Colab notebooks linked from my resume across generative modeling, computer vision, AI agents, and model serving.",
      "bullets": [
        "Open a notebook to review its code and research workflow."
      ],
      "links": [
        {
          "label": "WGAN-GP",
          "url": "https://colab.research.google.com/drive/10Rj44rBoJYIM3PZ87LDmxyY8lkMblIel?usp=sharing"
        },
        {
          "label": "Faster R-CNN",
          "url": "https://colab.research.google.com/drive/1HIgq600XTrVi54KSA5hlNucVbcbpPfva?usp=sharing"
        },
        {
          "label": "U-Net Semantic Segmentation",
          "url": "https://colab.research.google.com/drive/14jyH8SNMlIJNbRMKXny7JU07rDimKZOE?usp=sharing"
        },
        {
          "label": "Multimodal Image RAG",
          "url": "https://colab.research.google.com/drive/1EZv1bwPsULT-500T08BxVksyHR1wkHv7"
        },
        {
          "label": "LangGraph State Streaming",
          "url": "https://colab.research.google.com/drive/1KpQhQQude66BvyAFyr2Rr-PDAH8PPPDN?usp=sharing"
        },
        {
          "label": "LlamaIndex ReAct Agents",
          "url": "https://colab.research.google.com/drive/1hOYpsk_kVGNFUa6qmsiJdrFIZtdLEh3F?usp=sharing"
        },
        {
          "label": "PyTorch and Optuna HPO",
          "url": "https://colab.research.google.com/drive/1vH0eJHYQVuwyqZ1OlDl4S8xIUH78RyiE?usp=sharing"
        },
        {
          "label": "TensorFlow Serving",
          "url": "https://colab.research.google.com/drive/1YTwEfq5vfbqUtWTf2m9CG0koRWhRyhB4?usp=sharing"
        }
      ]
    }
  ],
  "leadership": [],
  "certifications": [
    {
      "name": "Deep Learning Specialization",
      "issuer": "Stanford University & DeepLearning.AI (Coursera)",
      "url": "https://www.credly.com/badges/e5fd8552-dc16-4b68-9aa4-d72b14a88c45/public_url",
      "highlights": []
    },
    {
      "name": "Machine Learning Specialization",
      "issuer": "Stanford University & DeepLearning.AI (Coursera)",
      "url": "https://coursera.org/share/16cc64926708910bdee1feb57457c06b",
      "highlights": []
    },
    {
      "name": "MLOps Specialization",
      "issuer": "Duke University (Coursera)",
      "url": "https://coursera.org/share/41a438d965a010105c175547b1cf0fc3",
      "highlights": []
    },
    {
      "name": "Building Transformer-Based NLP Applications",
      "issuer": "NVIDIA Deep Learning Institute",
      "url": "https://learn.nvidia.com/certificates?id=1aVlPQVVRoC9KTZO6T4EHQ",
      "highlights": []
    },
    {
      "name": "Engineer AI Agents with ADK",
      "issuer": "Google Cloud Skill Badge",
      "url": "https://www.credly.com/badges/93400df3-6283-4acc-ac57-2e9935af7059/public_url",
      "highlights": []
    }
  ],
  "awards": [],
  "skills": {
    "strong": [
      "Python",
      "PyTorch",
      "TensorFlow / Keras",
      "Computer Vision",
      "Audio Machine Learning",
      "Deep Learning & Generative Modeling",
      "On-Device / Edge Inference",
      "MLOps & Model Deployment"
    ],
    "moderate": [
      "SQL & Bash",
      "LiteRT / TensorFlow Lite",
      "TensorFlow.js / WebGL",
      "TFX & Scikit-learn",
      "FastAPI & Flask",
      "Hugging Face & NVIDIA NeMo",
      "YAMNet & Roboflow",
      "Optuna, Weights & Biases, and CometML",
      "PEFT / LoRA / GRPO",
      "Multi-GPU / DDP",
      "NVIDIA Isaac Sim & Isaac Lab",
      "MCP, LangChain, LangGraph, LlamaIndex, and Google ADK",
      "Git, Docker, GitHub Actions, GHCR, Conda, Linux, and n8n",
      "AWS, Azure, GCP, and Firebase"
    ],
    "gaps": []
  }
} as const
